export const QA_NAME_ADD_CC_BTN = 'addCC'

export const QA_NAME_ADD_BCC_BTN = 'addBCC'

export const QA_NAME_RECIPIENTS_FILTER_BTN = 'filter'
